'use client';

import HoverClickPopout from '~/components/HoverClickPopout';
import TitleLink from '~/components/TitleLink';
import { REVIEW_DOCS_BASE_URL } from '~/config';
import usePopover from '~/hooks/usePopover';
import { ArrowUpRight, BookOpen, CircleHelp, Mail, X } from 'lucide-react';

import NavBarItem from './NavBarItem';
import {
  NavPopoverBody,
  NavPopoverFooter,
  NavPopoverHeader,
  NavPopoverShell,
  navPopoverFooterLinkClass,
  navPopoverIconButtonClass,
} from './NavPopoverShell';

type HelpButtonProps = {
  isSidebarExpanded: boolean;
};

export default function HelpButton(props: HelpButtonProps) {
  const { open, handleClose, handleOpen, anchorEl } = usePopover<HTMLElement>();

  const renderHelpContent = (closePopout: () => void) => (
    <NavPopoverShell width={320}>
      <NavPopoverHeader
        title="Help"
        actions={
          <button
            type="button"
            className={navPopoverIconButtonClass}
            onClick={closePopout}
            aria-label="Close"
          >
            <X className="size-3.5" />
          </button>
        }
      />
      <NavPopoverBody className="space-y-3 px-4 py-3">
        <TitleLink
          title="Resources"
          icon={BookOpen}
          link={{
            text: 'Protege Knowledge Base',
            href: REVIEW_DOCS_BASE_URL,
          }}
        />
        <div className="border-border border-t" />
        <TitleLink
          title="Email Us"
          icon={Mail}
          link={{
            text: 'founders@tryprotege.com',
            href: 'mailto:founders@tryprotege.com',
          }}
          description={`You'll receive a response from our team within 24 hours, Monday - Friday.`}
        />
        <div className="border-border border-t" />
        <TitleLink
          title="Chrome Extension"
          link={{
            text: 'Install Chrome extension',
            href: 'https://chromewebstore.google.com/detail/pknoakkhmfneejkpnjfgkcnphpjhjcmf?utm_source=item-share-cb',
          }}
        />
      </NavPopoverBody>
      <NavPopoverFooter>
        <a
          className={navPopoverFooterLinkClass}
          target="_blank"
          href={`${REVIEW_DOCS_BASE_URL}/release-notes`}
          rel="noreferrer"
        >
          <span>What&apos;s New</span>
          <ArrowUpRight className="size-3.5" />
        </a>
      </NavPopoverFooter>
    </NavPopoverShell>
  );

  return (
    <HoverClickPopout
      renderContent={renderHelpContent}
      isOpen={open}
      anchorEl={anchorEl}
      onOpen={handleOpen}
      onClose={handleClose}
      width="320px"
      fullWidth
      openOnHover={false}
      offset={0}
      alignToContentPaneBottom
    >
      <NavBarItem
        label="Help"
        icon={CircleHelp}
        isSidebarExpanded={props.isSidebarExpanded}
        asButton
        disableTooltip={props.isSidebarExpanded}
      />
    </HoverClickPopout>
  );
}
